import React, { useEffect } from 'react'
import { fetchApplication } from 'careers/actions/application'
import FetchWithSpinner from 'components/fetch-with-spinner'
import JobAdQuickInterview from 'careers/pages/job-ad-quick-interview'
import { useParams } from 'react-router-dom'
import { setUnpublished } from 'careers/actions/job-ad'
import { httpError } from 'actions/http'
import { useDispatch } from 'react-redux'


function ContinueApplication() {
  const params = useParams()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(httpError(null))
    dispatch(setUnpublished(false))
  }, [])

  return (
    <FetchWithSpinner action={() => fetchApplication(params)}>
      <JobAdQuickInterview />
    </FetchWithSpinner>
  )
}

export default ContinueApplication
